module.exports = __webpack_public_path__ + "static/media/icon_iMessage_logo.fb747973.png";